// extracted by mini-css-extract-plugin
module.exports =  {"button-container":"button-container-PmUa2","label":"label-sAyL4"};